import React from 'react';
import logo from 'assets/img/brand/company_logo.png';
import { moneyFormatter } from 'utli';
import './printStyle.scss';
import moment from 'moment';

class CommercialInvoicePrintComponent extends React.Component {
  render() {
    const { data } = this.props;

    if (!data) return null;

    // Calculate subtotal from items only
    const subtotal = data?.items?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;

    // Get other service charges
    const otherServiceCharges = parseFloat(data?.other_service_charges) || 0;

    // Calculate total amount (subtotal + other service charges)
    const totalAmount = subtotal + otherServiceCharges;

    return (
      <div className='deposit-invoice-print'>
        {/* Header */}
        <div className='print-header'>
          <div className='header-row'>
            <div className='logo-section'>
              <div className='logo-wrapper'>
                <img src={logo} alt='Company Logo' className='company-logo' />
                <div className='company-info'>
                  <p className='company-name'>EASTY FREIGHT INTERNATIONAL LOGISTICS COMPANY LIMITED</p>
                  <p className='company-address'>[No.47, May Kha Street, May Kha Housing, Thingangyun Twsp, Yangon]</p>
                </div>
              </div>
            </div>
            <div className='invoice-title'>
              <h1>COMMERCIAL INVOICE</h1>
              <h3>[ Import License ]</h3>
            </div>
          </div>
          <div className='header-border'></div>
        </div>

        {/* Date and Sale Person */}
        <div className='info-row'>
          <table className='info-table'>
            <tbody>
              <tr>
                <td className='label-cell'>Date</td>
                  <td className='value-cell'>{data?.invoice_date ? moment(data.invoice_date).format('DD-MMM-YYYY') : '-'}</td>
                
              </tr>
              <tr>
                <td className='label-cell'>Sale Person</td>
                <td className='value-cell'>{data?.sale_person?.name || '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Customer and Deposit Information */}
        <div className='main-info-section'>
          <div className='customer-info'>
            <h3 className='section-title'>Customer Information</h3>
            <div className='info-item'>
              <span className='label'>Customer Name</span>
              <span className='value'>{data?.receiver?.name || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Customer Code</span>
              <span className='value'>{data?.address_code || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Customer Address</span>
              <span className='value'>{data?.receiver?.address || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Contact Phone No.</span>
              <span className='value'>{data?.receiver?.phone || '-'}</span>
            </div>
          </div>

          <div className='deposit-info'>
            <div className='deposit-info-container'>
              <h3 className='section-title'>Invoice Information</h3>
              <div className='info-item'>
                <span className='label'>CIV No.</span>
                <span className='value'>{data?.invoice_number || '-'}</span>
              </div>
              <div className='info-item'>
                <span className='label'>DIV No.</span>
                <span className='value'>{data?.ref_no || '-'}</span>
              </div>
              <div className='info-item'>
                <span className='label'>QT No.</span>
                <span className='value'>{data?.deposit_invoice?.quotation_no || '-'}</span>
              </div>
              <div className='info-item'>
                <span className='label'>License No.</span>
                <span className='value'>{data?.license_no}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Licence & Service Details */}
        <div className='service-section' style={{ minHeight: "450px" }}>
          <h3 className='section-title'>License & Service Details</h3>
          <table className='items-table'>
            <thead>
              <tr>
                <th className='sr-col'>SR NO</th>
                <th className='item-col'>ITEM NAME</th>
                <th className='unit-col'>UNIT</th>
                <th className='qty-col'>QTY</th>
                <th className='particulars-col'>PARTICULARS</th>
                <th className='amount-col' style={{ textAlign: 'right' }}>AMOUNT ({data?.currency})</th>
              </tr>
            </thead>
            <tbody>
              {data?.items && data.items.length > 0 ? (
                data.items.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td style={{ textAlign: 'left' }}>{item.itemname || '-'}</td>
                    <td>{item.unit || '-'}</td>
                    <td>{item.qty || '-'}</td>
                    <td>{item.remark || '-'}</td>
                    <td style={{ textAlign: 'right' }}>{item.amount ? moneyFormatter(item.amount) : '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='6' className='center'>No items</td>
                </tr>
              )}
              {/* Total Rows */}


              <tr className='other-charges-row'>
                <td colSpan='4' style={{ border: "none" }}></td>
                <td className='total-label' style={{ textAlign: "right", paddingRight: 20, fontWeight: "bold", fontSize: 10, textTransform: "uppercase", border: "1px solid black", borderTop: "1px solid black", borderBottom: "1px solid black", borderLeft: "1px solid black", borderRight: "1px solid black" }}>OTHER SERVICE CHARGES</td>
                <td className='total-amount' style={{ textAlign: "right", border: "1px solid black", borderTop: "1px solid black", borderBottom: "1px solid black", borderLeft: "1px solid black", borderRight: "1px solid black" }}>{moneyFormatter(otherServiceCharges)}</td>
              </tr>
              <tr className='total-row subtotal-row'>
                <td colSpan='5' className='total-label' >SUB TOTAL</td>
                <td className='total-amount'>{moneyFormatter(subtotal)}</td>
              </tr>

              <tr className='total-row deposit-row'>
                <td colSpan='5' className='total-label'>DEPOSIT PAID</td>
                <td className='total-amount'>{moneyFormatter(data?.deposit_invoice?.total_amount || 0)}</td>
              </tr>
              <tr className='total-row balance-row'>
                <td colSpan='5' className='total-label'>TOTAL BALANCE</td>
                <td className='total-amount'>{totalAmount>(data?.deposit_invoice?.total_amount || 0)?moneyFormatter(totalAmount - (data?.deposit_invoice?.total_amount || 0)):totalAmount - (data?.deposit_invoice?.total_amount || 0)}</td>
              </tr>
            </tbody>
          </table>
        </div>



        {/* Bank Information */}
        <div className='bank-section'>
          <h3 className='section-title'>Bank Information for Payment</h3>
          <table className='bank-table'>
            <thead>
              <tr>
                <th className='sr-col'>Sr.</th>
                <th className='bank-name-col'>Bank Name</th>
                <th className='account-name-col'>Account Name</th>
                <th className='account-number-col'>Account Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>KBZ-BANK</td>
                <td>U SOE MIN ZAW</td>
                <td>0275 110 3800 226 801</td>
              </tr>
              <tr>
                <td >2</td>
                <td>YOMA-BANK</td>
                <td>U SOE MIN ZAW</td>
                <td>000 345 480 000 813</td>
              </tr>
              <tr>
                <td >3</td>
                <td>CB-BANK</td>
                <td>U SOE MIN ZAW</td>
                <td>0003 1009 0000 9938</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Signatures */}
        <div className='signature-section' style={{ marginTop: "75px" }}>
          <div className='signature-box'>
            <p className='signature-title'>Received By / Customer</p>
            <div className='signature-line'></div>
            <p className='signature-label'>Signature</p>
            <p className='signature-label'>Name</p>
          </div>
          <div className='signature-box'>
            <p className='signature-title'>Checked By / Finance</p>
            <div className='signature-line'></div>
            <p className='signature-label'>Signature</p>
            <p className='signature-label'>Name</p>
          </div>
          <div className='signature-box'>
            <p className='signature-title'>Verified By / Sales</p>
            <div className='signature-line'></div>
            <p className='signature-label'>Signature</p>
            <p className='signature-label'>Name</p>
          </div>
        </div>
      </div>
    );
  }
}

export default CommercialInvoicePrintComponent;
